import { render, staticRenderFns } from "./TrainerList.vue?vue&type=template&id=70579c0e"
import script from "./TrainerList.vue?vue&type=script&lang=js"
export * from "./TrainerList.vue?vue&type=script&lang=js"
import style0 from "./TrainerList.vue?vue&type=style&index=0&id=70579c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports